<template>
<div style="width: 100%;">



<v-layout   d-flex style="overflow:hidden">
<v-card >
<v-toolbar height="42" flat>
  <v-toolbar-title>Основные данные</v-toolbar-title>

<v-spacer> </v-spacer>
<v-tooltip  top  max-width="250">
  <span>Кликните, что бы проверить валидность всех аккаунтов</span>
  <v-btn slot="activator" icon  color="green"  flat > <v-icon>mdi-account-check</v-icon></v-btn>
 </v-tooltip>


<v-tooltip   top  max-width="250">
  <span>Модифицировать данный список аккаунтов</span>
  <v-btn slot="activator"  icon  color="#273C51"  flat > <v-icon>mdi-pencil</v-icon></v-btn>
</v-tooltip>


<v-tooltip   top  max-width="250">
  <span>Настройка отображения таблицы</span>
  <v-btn slot="activator"  icon  color="#273C51"  flat > <v-icon>mdi-tune</v-icon></v-btn>
</v-tooltip>

</v-toolbar>
<v-card-text >

<div style="width:63%;margin-bottom:25px">


<filters :accounts="accounts" :filters="filters"> </filters>



</div>



<div style="width:800px;overflow-x:scroll">
<b-table   striped hover :items="accounts.itemsToDisplay" :fields="accounts.fields">
</b-table>
</div>

</v-card-text>
</v-card>






</v-layout>


</div>
</template>




<script>
import axios from 'axios'
import filters from './filter.vue'
export default {
components:{filters},
 data(){
  return {

filters:{
is:true,
cats:{
lists:{
mainList:{is:false},
friendList:{is:false},
autoregList:{is:false},
othersList:{is:false},
},
proxy:{
with:{is:true},
without:{is:true},
},
valid:{
valid:{is:true},
invalid:{is:true},
}
},
},

accounts:{
fields:[
  {key:'vkId',label:'Аккаунт'},
  {key:'grId',label:'Группа'},
  {key:'valid',label:'Валидный'},
  {key:'proxy',label:'Прокси'},

],
items: [],
itemsFilters: [],
itemsToDisplay:[],
},

filtersFields:{
fields:[
  {key:'vkId',label:'Список аккаунтов'},
  {key:'grId',label:'Группа'},
  {key:'valid',label:'Валидный'},
  {key:'proxy',label:'Прокси'},
  {key:'login',label:'Логин и пароль'},
  {key:'token',label:'Токен'},
],
items: []
},


  }
},


created(){
this.getFullinfo()
},



methods:{

getFullinfo(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/get_fullinfo.php', {
contentType: 'JSONP',
method: 'get',
}).then(response => {
  this.accounts.items = response.data
  //this.accounts.itemsToDisplay = response.data
})

},



}
}
</script>

<style>

</style>
